interface HeaderProps {
  title: string;
  subtitle: string;
}

export const Header: React.FC<HeaderProps> = ({ title, subtitle }) => (
  <>
    <h1 className="text-4xl font-bold mt-4">{title}</h1>
    <p className="text-gray-600 mt-2 mb-0">{subtitle}</p>
  </>
);
